import { defineComponent as _defineComponent } from 'vue'
import PageHeading from "@/components/PageHeading.vue";
import { MetadataKeys } from "@/types";
import { useViewAnalytics } from "@/composition/useViewAnalytics";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const pageName = ref("FAQ");
const { pageTitle, setAnalyticsMetadata, pushPageViewEvent } =
  useViewAnalytics(pageName);

const panelModel = ref([]);
const hideVideo = ref(false);

const faqs = [
  {
    question: "1. What is Almanac+",
    answer:
      "Combining the best of The Almanac of American Politics with National Journal’s analyst-driven people research <i>(formerly Vignette)</i>, Almanac+ is a robust database of contact information and downloadable profiles for policymakers and their staff, at the federal and state level. Use Almanac+ to prepare for meetings and engage with like-minded champions.",
  },
  {
    question: "2. Why did we combine Almanac and Vignette?",
    answer:
      "By merging National Journal’s suite of people products, we’ve created a comprehensive one-stop shop. Now, our members can access all contact information and downloadable profiles for both federal and state policymakers in a single database.",
  },
  {
    question: "3. What’s new?",
    answer:
      "<ul><li>Select Almanac+ profiles are now expanded to include additional research intelligence." +
      " Our goal is to give our members not only the details and facts about an individual that are relevant" +
      " to their interactions with them, but also to provide an analytical narrative to gain a deeper understanding " +
      "about how a person ticks.</li>" +
      "<ul><li><b>Analyst-driven sections of profiles include:</b> " +
      "Quick Summary, Approach & Motivations; Policy Positions & Areas of Focus; Core Communities; " +
      "Criticisms and Controversies, Professional Affiliations</li></ul>" +
      "<li>Select Profiles will also include:</li><ul><li><b>Special Interest Group Ratings:</b> Auto populated from VoteSmart</li>" +
      "<li><b>Campaign finance info:</b> Auto populated from Center for Responsive Politics</li>" +
      "<li><b>Key Votes:</b> Selected key bills selected by Almanac+ team, and KnowWho auto-populates the candidate’s vote on those bills</li>" +
      "</ul>" +
      "<li>Expanded Search functionality:</li>" +
      "<ul><li>Almanac+ will use more sophisticated search functionality and will allow our members to save and download " +
      "briefing books of profiles</li></ul>" +
      "<li>State Legislator Profiles and state staff</li>" +
      "<li>Candidate Profiles</li></ul>",
  },
  {
    question: "4. How often is the staff contact information updated?",
    answer: "Our data provider, KnowWho, pushes updates to contacts weekly.",
  },
  {
    question: "5. How often are profiles updated aside from the staff data?",
    answer:
      "All profile updates are driven by major events in the news cycle and will be prioritized ad-hoc for analyst-written sections of profiles.",
  },
  {
    question: "6. Profiles",
    answer:
      "<b>What types of profiles will be available?</b><ul><li>Enhanced analyst written profiles (formerly Vignette) will be available for:<ul><li>House of Representatives</li><li>Senators</li><li>State Governors</li><li>Cabinet Department Heads</li><li>SCOTUS Justices</li><li>Congressional Candidates</li><li>Presidential Candidates</li></ul></li><li>Contact information will be available for:<ul><li>Staff of U.S. Congress members</li><li>Staff of Congressional committees</li><li>Other Federal Executives and staff</li><li>State Legislators</li><li>Other State Executives</li></ul></li></ul>",
  },
  {
    question: "7. Sourcing & Methodology",
    answer:
      "<b>Where do you find all of this information?</b><ul><li>All the information that we have incorporated into the profiles to date is public record. Our research team culls from dozens of publicly available data sources like the <i>Almanac of American Politics</i>, lobbying disclosures, hearing testimony, speeches, media appearances, published works, campaign speeches, etc.</li></ul><b>How do you select what sections you cover in “Policy Positions and Areas of Focus”?</b><ul><li>In this section, we cover the policy areas that this particular individual works most closely on. We weigh a number of factors to ID what their top 3-4 policy issues and areas of focus are. For members of Congress, we look at bills they’ve introduced or issues they are active with on their committee.</li><li>We look at issues they speak frequently on to the press. We also look at what individuals speak the most on, bills they have sponsored as well as what they’ve focused on based on personal connection (ex: family/close personal connection to issues (i.e. health issues), small business owner background, family with a disability).</li><li>We look into personal, professional, and political relationships, experiences and groups that contribute to their rise.<ul><li>Personal: Strong connection to their alumni network or a Veterans group.</li><li>Professional: Where they used to work and if they’ve continued to work together or have a relationship (ex: investment banking community).</li><li>Members of Congress: Where their staffers come from, groups that they partner with (ex: climate activists), who they frequently co-sponsor bills with.</li><li>Political: Key endorsements & big donors/interest groups.</li></ul></li></ul><b>How do you decide what goes into the “criticism and controversy” section?</b><ul><li>Our team does not go hunting for this section. Instead, they report what is publically apparent in a quick scan of their record and career. Our analysts do newsroom training to be as objective as possible and have a high bar for what controversies and criticisms are worth mentioning.</li><li>Some profiles do not include this section if there is nothing that meets the high bar we have set.</li><li>Use Case: Many of our members are using this section to vet their PAC donations.</li></ul><b>What if I want to customize the profile to focus on my issues?</b><ul><li>Download any profile in an editable Word document in your own branding so you can add to your own notes.</li></ul><b>Where do you find the information for campaign contributions?</b><ul><li>We typically pull the top industry and corporate contributors from Open Secrets and then find the individual contributors by filtering the top aggregated donations on followthemoney.org.</li></ul>",
  },
];

onMounted(() => {
  setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Member Content Page");
  setAnalyticsMetadata(MetadataKeys.SITESECTION, "AlmanacPlus");
  pushPageViewEvent();

  try {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    document.head.appendChild(script);
  } catch {
    hideVideo.value = true;
  }
});

return { __sfc: true,pageName, pageTitle, setAnalyticsMetadata, pushPageViewEvent, panelModel, hideVideo, faqs, PageHeading }
}

})